import { connect } from "react-redux";
import COSInvoiceListPage from "./COSInvoiceListPage";
import {
  getCreatedCosInvoicesRequest,
  RemoveReviewCaseNoteList,
  changeNDISClaimCaseNoteInvoiceStatusRequest,
} from "store/actions/ah.actions";
import {
  createdCosInvoicesLoader,
  getCOSInvoiceLoaderSelector,
  getCreatedCosInvoiceSelector,
  changeNDISCaseNotesInvoiceStatusLoadingSelector,
} from "store/selector/ah.selector";
import {
  cosInvoiceModeSelector,
} from "store/selector/cos.selector";
import {
  getCosInvoiceModeRequest,
  updateCosInvoiceModeRequest,
} from "store/actions/cos.actions";

const mapDispatchToProps = {
  emptyTableData: RemoveReviewCaseNoteList,
  getInvoicesList: getCreatedCosInvoicesRequest,
  changeInvoiceStatus: changeNDISClaimCaseNoteInvoiceStatusRequest,
  getCosInvoiceMode: getCosInvoiceModeRequest,
  updateCosInvoiceMode: updateCosInvoiceModeRequest,
};

const mapStateToProps = (state) => {
  const cosInvoiceLoading = getCOSInvoiceLoaderSelector(state);
  const createdCosInvoiceLoading = createdCosInvoicesLoader(state);
  const createdCosInvoice = getCreatedCosInvoiceSelector(state);
  const changeInvoiceStatusLoading = changeNDISCaseNotesInvoiceStatusLoadingSelector(state);
  const cosInvoiceMode = cosInvoiceModeSelector(state);

  return {
    cosInvoiceLoading,
    createdCosInvoiceLoading,
    createdCosInvoice,
    changeInvoiceStatusLoading,
    cosInvoiceMode,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(COSInvoiceListPage);
